import { useState, useEffect } from "react";
import type { Slot, Trainer } from "@/utils/booking";

export const useSignUpDate = (date: string, trainers: Trainer[], slots: Slot[]) => {
  const [trainersNames, setTrainersNames] = useState<string[]>([]);
  useEffect(() => {
    const uniqueTrainers: string[] = [];
    slots.forEach((slot) => {
      if (slot.date_time.startsWith(date)) {
        trainers.forEach((trainer) => {
          if (trainer.id === slot.employee_id) {
            if (!uniqueTrainers.includes(trainer.name)) {
              uniqueTrainers.push(trainer.name);
            }
          }
        });
      }
    });
    setTrainersNames(uniqueTrainers);
  }, [date, slots, trainers]);
  return {
    trainersNames,
  };
};
